import { func, shape, string } from 'prop-types';
import React from 'react';
import DoubleScrollbar from 'react-double-scrollbar';

import { campaignShape } from '../../prop-types';
import ChangeProductBudgetTable from './ChangeProductBudgetTable';
import { productAggregatesMapShape } from './constants';

function ChangeProductBudgetForm({ value, onChange, campaign }) {
  const { productAggregates: productAggregatesMap, delta } = value;
  return (
    <DoubleScrollbar>
      <ChangeProductBudgetTable
        productAggregatesMap={productAggregatesMap}
        delta={delta}
        onChange={onChange}
        campaign={campaign}
      />
    </DoubleScrollbar>
  );
}

ChangeProductBudgetForm.propTypes = {
  onChange: func.isRequired,
  campaign: campaignShape.isRequired,
  value: shape({
    commercialIncentive: string,
    productAggregates: productAggregatesMapShape.isRequired,
  }).isRequired,
};

export default ChangeProductBudgetForm;
